import styled, {css} from 'styled-components';
import {ticketsGroups, ticketCourseImg} from '../../../../assets/symbols/images/Images.css';
import {BGImageCenter, getStaticImage, mobileMedia} from '../../../../globalVariables/GlobalVariables';

export const container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  height: 100%;
`;
export const frame = styled.div`
  max-height: 100%;
  display: flex;
  flex-direction: column;
  ${p => p.$compact && css`
    height: 100%;
  `}
`;
export const image = styled.div`
  ${BGImageCenter(getStaticImage('app/firstTicket.png'), 'contain')});
  // background-image: url("${p => p.type === 'course' ? ticketCourseImg : ticketsGroups}");
  height: 250px;
  width: 250px;
  margin: 0 auto;
  max-height: calc(100% - 100px);
  ${mobileMedia}{
    max-height: calc(100% - 180px);

  }
  ${p => p.$compact && css`
      height: 180px;
      width: 180px;
  `}
`;
export const title = styled.div`
  width: 100%;
  padding: 7px;
  text-align: center;
  font-weight: 500;
  margin: 15px auto;
`;

